<template>
  <section id="companies" class="companies" aria-labelledby="company-section-header">
    <h2 id="company-section-header" class="companies__title">{{ title }}</h2>
    <div class="companies__wrapper">
      <div v-for="company in companies" :key="`company-${company.id}`" class="company">
        <div class="company__details">
          <div id="company-information" class="company-information">
            <h3>{{ company.name }}</h3>
            <div class="company-link">
              <form-button
                v-if="company.shortName"
                text="Lue lisää meistä"
                :aria-label="'Lue lisää yhtiöstä ' + company.name"
                theme="primary"
                @click="openCompanyLink(company)"
              />
            </div>
          </div>

          <div v-if="company.pricing" id="company-pricing" class="company-pricing">
            <div class="pricing-wrapper">
              <h4 class="company-pricing__title">Palveluhinnasto</h4>
              <a class="price-list-link" :href="company.pricing">
                <i class="icon-instructions-circled"></i>
                <span>Lataa palveluhinnasto (PDF)</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { agencies } from '@/app/routes';
import router from '../../router';
import { defineAsyncComponent } from 'vue';

export default {
  name: 'Companies',
  components: {
    FormButton: defineAsyncComponent(() => import('@/app/components/form-button/form-button.vue')),
  },
  props: {
    companies: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
  },
  data: () => ({
    companyRoute: `${agencies.path}/yhtio`,
  }),
  methods: {
    openCompanyLink(company) {
      void router.push(this.getCompanyUrl(company));
    },
    getCompanyUrl(company) {
      return `${this.companyRoute}/${company.shortName}`;
    },
  },
};
</script>
